import LoginNewPasswordContainer from './containers/LoginNewPasswordContainer';

export default LoginNewPasswordContainer;
